// Module
var code = `<div> <div class="current-step web-view-step"> <iframe allowfullscreen src="" tabindex="0" style="border: none; padding: 0; margin: 0; width: 100%; display: block;" sandbox="" allow="camera;microphone;clipboard-write"></iframe> </div> </div>`;
// Exports
export default code;